import React from 'react';
import moment from 'moment';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { userFullName, addressObject } from 'src/helpers';
import { TableLibrary } from 'src/components/complex';
import SVGIcon from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';
import cardModel from 'src/components/paymentCard/model';
import { MCButton, Logo } from 'src/components/basic';
import { popupModel } from 'src/components/complex';
import { PaymentNotice } from 'src/components/paymentCard/PaymentNotice';
import LANG_CONST from 'src/helpers/lang/const';
import { lang, remFontCss, remCss, withRouter, number } from 'src/helpers';
import MasterCardImage from 'src/assets/images/cards/master.png';
import VisaCardImage from 'src/assets/images/cards/visa.png';

import model from './model';
import StripePaymentMethod from 'src/components/paymentCard/StripePaymentMethod';
import StripeFormPayment from 'src/components/paymentCard/StripeFormPayment';

class Payment extends BaseComponent {
  state = { step: 'invoice', card: null, selectingCard: null };

  componentDidMount() {
    model.resetApiState('pay');
    model.baseSubscribe(this.subscription);
    cardModel.subscribe(this.subscription);
    cardModel.stripeList();
    let invoiceId = this.props.router.params.invoiceId;
    if (invoiceId) {
      model.createPaymentIntent(invoiceId);
      model.loadDetail(invoiceId, (err, data, success) => {
        if (success) {
          this.setState({ invoice: data, step: 'invoice', card: null, promoCode: false });
        }
      });
    } else {
      this.navigate(-1);
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    cardModel.unsubscribe(this.subscription);
  }

  pay = () => {
    const { invoice, promoCode } = this.state;
    let activeCard = this.state.card || cardModel.activeCard;
    if (!activeCard || activeCard.id === 'new') {
      this.showStripePopup();
    } else {
      model.pay(
        {
          id: invoice.id,
          cardId: activeCard?.id,
          promoCode
        },
        this.showPaymentResultPopup
      );
    }
  };

  showStripePopup = (inactive) => {
    let { clientSecret } = model.getState();
    let invoice = this.state.invoice;
    if (!clientSecret || !invoice) return;
    let doctorProfile = invoice?.doctor || {};
    let doctorName = userFullName(doctorProfile);
    let specialist = (doctorProfile.specialist && doctorProfile.specialist[0]) || '';
    let speciality = (specialist && LANG_CONST.constants.specialist[specialist]) || '';
    let description = lang.t('Consultation for Dr. ' + doctorName + ' ' + speciality);
    let amount = invoice.amount + ' ' + invoice.currency;
    console.log('invoice', invoice, description, amount);
    popupModel.setActivePopup('stripe_popup', {
      active: !inactive,
      component: (props) => (
        <StripeFormPayment
          {...props}
          title={'Payment'}
          description={description}
          amount={amount}
          model={model}
          options={{ clientSecret }}
          clientSecret={clientSecret}
          confirmPaymentIntent={(paymentIntent, cb) => {
            model.confirmPaymentIntent(paymentIntent, (err, res, success) => {
              this.showPaymentResultPopup(err, res, success);
              cb && cb(err, res, success);
            });
          }}
        />
      )
    });
  };

  showPaymentResultPopup = (err, data) => {
    let succeed = !err && data?.chargeResult.success;
    let activeCard = this.state.card || cardModel.activeCard;
    let invoice = data?.invoice;
    if (!succeed) return this.showStripePopup();
    popupModel.setActivePopup('payment_notice', {
      active: true,
      component: PaymentNotice,
      afterHide: () => {
        succeed ? this.navigate('/invoices') : this.showStripePopup();
      },
      props: {
        status: !succeed ? 'failed' : 'success',
        item: {
          ...invoice,
          date: Date.now(),
          sender: model.state.user,
          card: activeCard
        }
      }
    });
  };

  renderSelectCard = () => {
    const activeCard = this.state.selectingCard ||
      this.state.card ||
      cardModel.activeCard || { id: 'new' };
    let _cards = cardModel.state.cards || [];
    let cards = [..._cards].sort((card) => (card.active ? -1 : 1));
    // cards.push({ id: 'new' });
    return (
      <div className={'mc-flex-25-col mc-mt10'}>
        {cards.map((card) => (
          <div
            key={card.id}
            className={activeCard?.id === card.id ? 'mc-b-primary' : 'mc-b2-light'}
          >
            <StripePaymentMethod
              data={{
                ...card,
                active: activeCard?.id === card.id
              }}
              onClick={() => this.setState({ selectingCard: card })}
              onDelete={cardModel.stripeRemove}
            />
          </div>
        ))}
      </div>
    );
  };

  renderCardPreview = () => {
    const card = this.state.card || cardModel.activeCard;
    if (!card) return null;
    return (
      <div className='mc-flex'>
        <div style={{ marginRight: remCss(40) }}>
          <StripePaymentMethod data={{ ...card, active: true }} short />
        </div>
        <div
          data-testid='invoice-payment-change-card'
          className='mc-link-620'
          onClick={() => this.setState({ step: 'selectCard', selectingCard: null })}
        >
          {lang.t('Change')}
        </div>
      </div>
    );
  };

  renderInvoiceStep = () => {
    const { invoice } = this.state;
    const { user } = model.state;

    const patient = user.id === invoice.patientId ? user : invoice.patient;
    const doctor = user.id === invoice.userId ? user : invoice.doctor;

    return (
      <div className='mc-flex-10-col'>
        <div className='mc-flex mc-wrap' style={{ alignItems: 'initial' }}>
          <div className='mc-flex-5-col mc-grow'>
            <div className='mc-value-520'>{lang.t('Serie') + ': ' + (invoice.serie || '')}</div>
            <div className='mc-value-520'>{lang.t('Invoice No') + ': ' + invoice.invoiceNo}</div>
            <div className='mc-value-520'>
              {lang.t('Date') +
                ': ' +
                moment(
                  invoice.invoiceDate,
                  invoice.invoiceDate.toString().length === 8 ? 'YYYYMMDD' : ''
                ).format('DD/MM/YYYY')}
            </div>
          </div>

          <div className='mc-flex-5-col mc-grow'>
            <div className='mc-value-620'>{lang.t('Billing To')}:</div>
            <div className='mc-value-620'>{userFullName(patient)}</div>
            <div>
              <div className='mc-value-418'>
                {formatPhoneNumberIntl(patient.phoneNumber.toString())}
              </div>
              <div className='mc-value-418'>{patient.email}</div>
            </div>
          </div>
          <div className='mc-grow mc-flex-5-col'>
            <div className='mc-value-620'>{'Dr. ' + userFullName(doctor)}</div>
            <div className='mc-value-418'>
              {doctor.specialist
                ?.filter((v) => !!LANG_CONST.constants.specialist[v])
                .map((v) => lang.t(LANG_CONST.constants.specialist[v]))
                .join(', ')}
            </div>
            <pre className='mc-value-418'>
              {doctor.address} {addressObject(doctor).fullAddressNameReverse}
            </pre>
          </div>
          <div className='mc-grow' />
        </div>

        <div style={{ marginTop: remCss(10) }}>
          <TableLibrary
            template={5}
            showPagination={false}
            data={invoice.invoiceDetails}
            columns={[
              {
                label: 'SR',
                width: '13%',
                cellStyles: { paddingVertical: 16 },
                renderCell: (invoiceDetail, i) => String(i + 1).padStart(3, '0')
              },
              {
                label: 'Description',
                cellStyles: { paddingVertical: 16 },
                renderCell: (invoiceDetail) => (
                  <div style={{ whiteSpace: 'normal' }}>{invoiceDetail.description}</div>
                )
              },
              {
                label: 'Price',
                width: '15%',
                cellStyles: { paddingVertical: 16 },
                renderCell: (invoiceDetail) =>
                  `${number.format(invoiceDetail.price)} ${invoice.currency}`
              },
              {
                label: 'VAT',
                width: '12%',
                cellStyles: { paddingVertical: 16 },
                renderCell: (invoiceDetail) => invoiceDetail.vat + '%'
              },
              {
                label: 'Total',
                width: '20%',
                cellStyles: { textAlign: 'end', padding: `${remCss(16)}px ${remCss(30)}px` },
                renderCell: (invoiceDetail) =>
                  `${number.format(invoiceDetail.total)} ${invoice.currency}`
              }
            ]}
            footer={
              <div className='mc-flex mc-row mc-value-520'>
                <div className='mc-grow' />
                <div>{lang.t('Total') + ' :'}</div>
                <div style={{ padding: `${remCss(12)}px ${remCss(30)}px`, textAlign: 'right' }}>
                  {number.format(invoice.amount)} {invoice.currency}
                </div>
              </div>
            }
          />
        </div>
      </div>
    );
  };

  back = () => {
    if (this.state.step !== 'invoice') {
      this.setState({ step: 'invoice' });
    } else {
      // this.navigate(-1);
      this.navigate('/invoices');
    }
  };

  newCard = () => {
    this.setState({
      selectingCard: { id: 'new' },
      card: { id: 'new' },
      step: 'invoice'
    });
    this.showStripePopup();
  };

  render() {
    const { invoice, step } = this.state;
    const { invalid, loading, ...createState } = model.getApiState('pay');
    const scale = this.props.screenDetail?.isSmallScreen ? 0.7 : 1;
    let { clientSecret } = model.getState();
    return invoice ? (
      <div className={'mc-container-content mc-payment'}>
        <div
          data-testid='invoice-payment-header'
          className={'mc-container-content__header mc-flex-15'}
        >
          <div className={'mc-no-style-btn'} style={{ height: remCss(40) }} onClick={this.back}>
            <SVGIcon width={40} iconname={'back-icon'} />
          </div>
          <span className={'mc-grow'}>{lang.t('Payment')}</span>
        </div>
        <div className={'mc-container-content__body mc-p5'}>
          <div className={'mc-container-content__body-header'}>
            <div className='mc-value-522 mc-grow'>
              <div className='mc-flex'>
                <div>{lang.t(step === 'selectCard' ? 'Select Card' : 'Invoice')}</div>
                <div className={'mc-flex'}>
                  <img alt='mastercard' src={MasterCardImage} style={{ height: remCss(30) }} />
                  <img alt='visa' src={VisaCardImage} style={{ height: remCss(30) }} />
                </div>
              </div>
            </div>
            {step !== 'selectCard' && (
              <Logo
                logoProps={{ width: 42 * scale, height: 42 * scale }}
                titleProps={{ style: { fontSize: remFontCss(48 * scale) } }}
              />
            )}
            {step === 'selectCard' && (
              <MCButton
                style={{ minWidth: 150, marginRight: 15 }}
                primary
                large
                light
                radius
                medium
                outline
                onClick={this.newCard}
                label={lang.t('New card')}
              />
            )}
          </div>
          <div
            className={'mc-container-content__body-content'}
            style={{ padding: '0px remCss(25)' }}
          >
            {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
            {invalid?.cardId && <p className='mc-error'>{lang.t('Card is required.')}</p>}
            {this.state.step === 'invoice' && this.renderInvoiceStep()}
            {this.state.step === 'selectCard' && this.renderSelectCard()}
            <div style={{ display: this.state.step === 'card' ? 'initial' : 'none' }}>
              <StripeFormPayment
                model={model}
                options={{ clientSecret }}
                clientSecret={clientSecret}
                confirmPaymentIntent={(paymentIntent, cb) => {
                  model.confirmPaymentIntent(paymentIntent, (err, res, success) => {
                    this.showPaymentResultPopup(err, res, success);
                    cb && cb(err, res, success);
                  });
                }}
              />
            </div>
          </div>
          <div
            className={'mc-container-content__body-footer'}
            style={{ padding: `${remCss(20)}px ${remCss(25)}px` }}
          >
            {this.state.step === 'invoice' && (
              <div className={'mc-flex'}>
                <div className={'mc-grow'}>{this.renderCardPreview()}</div>
                <MCButton
                  style={{ minWidth: remCss(150) }}
                  primary
                  large
                  dark
                  radius
                  medium
                  disabled={loading}
                  onClick={() => this.pay()}
                >
                  {loading ? lang.t('Paying') + '...' : lang.t('Pay now')}
                </MCButton>
              </div>
            )}
            {this.state.step === 'selectCard' && (
              <div className={'mc-flex'}>
                <div className={'mc-grow'} />
                <MCButton
                  style={{ minWidth: remCss(150) }}
                  primary
                  large
                  light
                  radius
                  medium
                  onClick={() => this.setState({ step: 'invoice', selectingCard: null })}
                >
                  {lang.t('Back')}
                </MCButton>
                <MCButton
                  style={{ minWidth: remCss(150) }}
                  primary
                  large
                  dark
                  radius
                  medium
                  onClick={() => {
                    let card = this.state.selectingCard ||
                      this.state.card ||
                      cardModel.activeCard || { id: 'new' };
                    this.setState({
                      step: 'invoice',
                      selectingCard: null,
                      card
                    });
                    cardModel.stripeActive(card);
                  }}
                >
                  {lang.t('Select')}
                </MCButton>
              </div>
            )}
          </div>
        </div>
      </div>
    ) : null;
  }
}

export default withRouter(Payment);
